import { PureComponent, type ReactNode, StrictMode } from "react";
import { BrandListItemSkeleton } from "@App/Components/Vehicletree/BrandList";

export class MotorizationListSkeleton extends PureComponent {
  render(): ReactNode {
    return (
      <StrictMode>
        <div className={"animate-pulse"}>
          <div className="relative md:w-80 max-w-full">
            <div className="w-64 bg-black-300 h-8 mb-2 rounded-md" />
          </div>
          {[...Array(10)].map((e, i) => (
            <BrandListItemSkeleton key={i} />
          ))}
          <div className="w-64 bg-black-300 h-8 mt-3 mb-2 rounded-md" />
        </div>
      </StrictMode>
    );
  }
}
